import { PublicationDateContainer } from '../../containers/advancedFilters/PublicationDateContainer';
import { IFilter } from '../../types/advancedFilters';

export const publicationDate: IFilter = {
  component: PublicationDateContainer,
};
